module.exports = __webpack_public_path__ + "img/mic-icon.80669dbd.svg";